"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var CustomReplace_1 = require("./CustomReplace");
exports.CustomReplace = CustomReplace_1.default;
//# sourceMappingURL=index.js.map